import Navbar from "../Navbar"

export default function Header() {
    return (
        <header className="bg-secondary dark:bg-gray-900 overflow-visible">
            <Navbar />
        </header>
    )
}